export default __webpack_public_path__ + "static/media/item3.4067eb76.jpg";